export default __webpack_public_path__ + "static/media/bug-solid-cultured-50.3e723086.png";